export default "__VITE_ASSET__6MK4vk0y__"